import { useState } from 'react'
import { useNavigate } from 'react-router-dom'
import { useTranslation } from 'react-i18next'
import ManualContentKo, { SECTION_LABELS as SECTIONS_KO } from './manual/ManualContentKo'
import ManualContentEn, { SECTION_LABELS as SECTIONS_EN } from './manual/ManualContentEn'

export default function ManualPage() {
  const navigate = useNavigate()
  const { t, i18n } = useTranslation()
  const isEn = (i18n.resolvedLanguage ?? i18n.language)?.toLowerCase().startsWith('en')
  const SECTIONS = isEn ? SECTIONS_EN : SECTIONS_KO
  const [activeSection, setActiveSection] = useState('overview')

  const handleNavClick = (id: string) => {
    setActiveSection(id)
    document.getElementById(id)?.scrollIntoView({ behavior: 'smooth' })
  }

  return (
    <div style={{ width: '100vw', height: '100vh', display: 'flex', flexDirection: 'column', overflow: 'hidden' }}>

      {/* 헤더 */}
      <header className="h-12 bg-slate-900 flex items-center justify-between px-4 shrink-0 z-10">
        <div className="flex items-center gap-3">
          <img src="/gaia3d-logo.png" alt="Gaia3D" className="h-6 object-contain" />
          <span className="text-white text-sm font-semibold">{t('manual.title')}</span>
        </div>
        <button
          onClick={() => navigate('/dashboard')}
          className="text-xs text-slate-400 hover:text-white border border-slate-600 hover:border-slate-400 rounded px-3 py-1 transition-colors flex items-center gap-1.5"
        >
          <svg width="12" height="12" viewBox="0 0 24 24" fill="none" stroke="currentColor" strokeWidth="2" strokeLinecap="round" strokeLinejoin="round">
            <polyline points="15 18 9 12 15 6" />
          </svg>
          {t('manual.back')}
        </button>
      </header>

      {/* 본문 */}
      <div style={{ flex: 1, display: 'flex', overflow: 'hidden' }}>

        {/* 사이드 네비게이션 */}
        <nav className="w-52 bg-slate-50 border-r border-slate-200 shrink-0 overflow-y-auto py-6">
          <p className="text-[10px] font-bold text-slate-400 uppercase tracking-widest px-5 mb-3">{t('manual.toc')}</p>
          <ul>
            {SECTIONS.map(s => (
              <li key={s.id}>
                <button
                  onClick={() => handleNavClick(s.id)}
                  className={`w-full text-left px-5 py-2 text-sm transition-colors ${
                    activeSection === s.id
                      ? 'bg-blue-50 text-blue-700 font-semibold border-r-2 border-blue-600'
                      : 'text-slate-600 hover:bg-slate-100 hover:text-slate-900'
                  }`}
                >
                  {s.label}
                </button>
              </li>
            ))}
          </ul>
        </nav>

        {/* 콘텐츠 */}
        <main
          className="flex-1 overflow-y-auto px-10 py-8"
          onScroll={(e) => {
            const el = e.currentTarget
            for (const s of SECTIONS) {
              const sec = document.getElementById(s.id)
              if (sec && sec.offsetTop - el.scrollTop <= 120) {
                setActiveSection(s.id)
              }
            }
          }}
        >
          <div className="max-w-3xl mx-auto">

            {isEn ? <ManualContentEn /> : <ManualContentKo />}

            <div className="border-t border-slate-200 pt-6 pb-10 text-center text-xs text-slate-400">
              © Gaia3D, Inc. — Mago 3D Reality Mesh Service
            </div>

          </div>
        </main>
      </div>
    </div>
  )
}
